/**
 * USER API MODULE
 * Handles all API calls related to user data management
 * Includes points, target points, goals, and user profile operations
 */

// AWS Amplify for API calls
import { API } from 'aws-amplify';

/**
 * Update user's current points
 * @param {number} points - New points value
 * @returns {Object} Response body from API
 */
export const updatePoints = async (points) => {
  const response = await API.post('rules', '/update_points', {
    headers: { 'Content-Type': 'application/json' },
    body: { points },
  });
  let body;
  try {
    body = response.body;
  } catch (e) {
    console.error(e);
  }
  return body;
};

/**
 * Update user's target points goal
 * @param {number} targetPoints - New target points value
 * @returns {Object} Response body from API
 */
export const updateTargetPoints = async (targetPoints) => {
  const response = await API.post('rules', '/update_target_points', {
    headers: { 'Content-Type': 'application/json' },
    body: { target_points: targetPoints },
  });
  let body;
  try {
    body = response.body;
  } catch (e) {
    console.error(e);
  }
  return body;
};

/**
 * Fetch current user data
 * @returns {Array} User data array
 */
export const getUser = async () => {
  const response = await API.get('rules', '/get_user_data', {});
  let body = [];
  try {
    body = response.body;
  } catch (e) {
    console.error(e);
  }
  return body;
};

/**
 * Fetch user's current goal
 * @returns {Object} Goal data object
 */
export const getGoal = async () => {
  const response = await API.get('rules', '/get_goal', {});
  let body = {};
  try {
    body = response.body;
  } catch (e) {
    console.error(e);
  }
  return body;
};

/**
 * Update user's goal
 * @param {Object} goalData - Goal data object
 * @returns {Array} Response body from API
 */
export const updateGoal = async (goalData) => {
  const response = await API.post('rules', '/update_goal', {
    headers: { 'Content-Type': 'application/json' },
    body: goalData,
  });
  let body = [];
  try {
    body = response.body;
  } catch (e) {
    console.error(e);
  }
  return body;
};

/**
 * Fetch all user's goals
 * @returns {Object} Goals data object
 */
export const getMyGoals = async () => {
  const response = await API.get('rules', '/get_my_goals', {});
  let body = {};
  try {
    body = response.body;
  } catch (e) {
    console.error(e);
  }
  return body;
};